// extracted by mini-css-extract-plugin
export default {"detailsIcon":"SiteRowContainer-detailsIcon-3710cfe06563b47a3760f82667099684"};